import {createTheme as createMuiTheme} from '@material-ui/core/styles';
import createColor from 'utils/material';

const contrastThreshold = 3;
const tonalOffset = 0.2;

const options = {
  direction: 'rtl',
  palette: {
    primary: {
      main: '#30ACFF',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#294e79',
    },
    error: {
      main: '#ff0000',
    },
    warning: {
      main: '#f0ad4e',
    },
    info: {
      main: '#30ACFF',
    },
    success: {
      main: '#10d0a0',
      contrastText: '#ffffff',
    },
    light: {
      main: '#fff',
    },
    notice: createColor('#ffe000', contrastThreshold, tonalOffset),
    gray: createColor('#cccccc', contrastThreshold, tonalOffset),
    contrastThreshold,
    tonalOffset,
  },
  typography: {
    fontFamily: 'IRANSans',
  },
  overrides: {
    MuiAppBar: {
      root: {
        '& h6': {
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          fontFamily: 'IRANSansX',
          fontSize: '18px',
          fontWeight: 600,
          paddingRight: '4px',
          paddingLeft: '4px',
          color: '#1D2129',
        },
      },
    },
    MuiToolbar: {
      gutters: {
        paddingLeft: '12px',
        paddingRight: '12px',
      },
    },
    MuiPaper: {
      root: {
        borderBottom: '1px solid #F2F3F5',
      },
    },
    MuiGrid: {
      container: {
        width: '100% !important',
        margin: '0 !important',
      },
    },
    MuiBottomNavigationAction: {
      root: {
        paddingLeft: 0,
        paddingRight: 0,
        minWidth: 50,
      },
      label: {
        fontSize: 8,
        '&$selected': {
          fontSize: 10,
        },
      },
    },
    MuiLink: {
      root: {
        color: 'inherit',
      },
    },
  },
};

const theme = createMuiTheme(options);

export const themeLtr = createMuiTheme({
  ...options,
  direction: 'ltr',
});

export default theme;
